import { Card, Box, Skeleton } from '@mui/material'

import styles from './articleCard.styles'

const SkeletonCard = () => (
  <Box sx={styles.root}>
    <Card sx={styles.card}>
      <Box
        sx={{ display: 'flex', flexDirection: 'column', p: 'var(--spacing-l)' }}
      >
        <Skeleton height={16} width={90} />
        <Skeleton height={90} />
        <Skeleton height={16} width={130} />
      </Box>
    </Card>
  </Box>
)

export default SkeletonCard
